import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';

const validationSchema = object().shape({
  triageTypeId: string().nullable().required('Field is required'),
});

export default yupResolver(validationSchema);
